export const isUnitFaction = (unit, factionId) => {
  return unit.factionId === factionId
}